import {
  AanvraagClient,
  ApplicationConfigClient,
  AttachmentClient,
  AttachmentOverviewClient,
  AuthorizeClient,
  BelanghebbendenEnPartnersClient,
  GeneralClient,
  IndieningClient,
  PartijInfoClient,
  KostenClient,
  LocalisatieClient,
  OmschrijvingClient,
  OverzichtClient,
  ProjectInfoClient,
  UserCodeClient,
  AanvraagStatusClient,
  ContactGegevensClient,
} from './proxy';

export const Clients = [
  AanvraagClient,
  AanvraagStatusClient,
  ApplicationConfigClient,
  AttachmentClient,
  AttachmentOverviewClient,
  AuthorizeClient,
  BelanghebbendenEnPartnersClient,
  GeneralClient,
  IndieningClient,
  PartijInfoClient,
  ProjectInfoClient,
  KostenClient,
  LocalisatieClient,
  OmschrijvingClient,
  OverzichtClient,
  UserCodeClient,
  ContactGegevensClient,
];
